export function priceFormat (data) {
  let price = Number(data)
  if (data && data !== 0) {
    price = Number(price.toFixed(3)).toLocaleString().replace(/,/, '.')
  }
  return price
}
